/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesSl = {
  privacy: {
    pageTitle: "Pravilnik o zasebnosti",
    lastUpdated: "Zadnja posodobitev: 1. junij 2026",
    introduction: {
      title: "Uvod",
      body: "WasOK je lokalno usmerjena aplikacija za pomoč pri nakupovanju, zasnovana tako, da uporabnikom pomaga zapomniti izdelke, ki so jih prej kupili, ocenili ali pregledali.\n\nTa pravilnik o zasebnosti pojasnjuje, katere informacije se obdelujejo pri uporabi aplikacije, kako se podatki shranjujejo in kako lahko delujejo določene storitve tretjih oseb.",
    },
    dataStored: {
      title: "Podatki, ki jih shrani aplikacija",
      body: "WasOK lokalno na vaši napravi shrani naslednje informacije:\n\n• optično prebrane črtne kode izdelkov\n• imena izdelkov in podrobnosti, ki jih vnese uporabnik\n• ocene in komentarje\n• nakupovalne sezname\n• kategorije izdelkov\n• cene in podatke o trgovinah\n• fotografije izdelkov in trgovin\n\nVaši podatki o izdelkih in fotografije se ne nalagajo na strežnike WasOK.",
    },
    permissions: {
      title: "Uporabljena dovoljenja",
      camera: {
        title: "Kamera",
        body: "Dostop do kamere se uporablja za:\n\n• skeniranje črtnih kod\n• fotografiranje izdelkov",
      },
      photos: {
        title: "Fotografije in mediji",
        body: "Dostop do fotografij ali galerije se uporablja le pri:\n\n• prilaganju slik k izdelkom\n• obnovitvi varnostnih kopij, ki vsebujejo fotografije",
      },
      files: {
        title: "Dostop do datotek in shrambe",
        body: "Dostop do datotek se lahko uporablja za:\n\n• izvoz datotek varnostnih kopij\n• uvoz varnostnih kopij, ki jih izbere uporabnik\n• deljenje nakupovalnih seznamov ali varnostnih kopij",
      },
    },
    backup: {
      title: "Funkcije varnostnega kopiranja in izvoza",
      body: "WasOK uporabnikom omogoča ustvarjanje datotek varnostnih kopij, ki vsebujejo podatke aplikacije in po želji fotografije.\n\nDatoteke varnostnih kopij se ustvarijo lokalno na vaši napravi in jih je mogoče shraniti ali deliti prek storitev, ki jih izbere uporabnik, na primer:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokalna shramba naprave\n\nWasOK ne nalaga varnostnih kopij na lastne strežnike.",
      onlineProductLookup: {
        title: "Spletno iskanje izdelkov",
        body: "Ko v Nastavitvah omogočite spletno iskanje črtnih kod, lahko WasOK pošlje samo optično prebrano številko črtne kode javnim zbirkam izdelkov (na primer Open Food Facts), da predlaga ime izdelka in blagovno znamko. WasOK za to funkcijo ne nalaga vaših ocen, komentarjev, fotografij, nakupovalnih seznamov, kategorij, podatkov o trgovinah ali podatkov varnostnih kopij. To funkcijo lahko kadar koli izklopite v Nastavitvah.",
      },
    },
    advertising: {
      title: "Oglaševanje in storitve tretjih oseb",
      intro:
        "WasOK uporablja izbrane storitve tretjih oseb za zagotavljanje določenih funkcij.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob se uporablja za prikazovanje oglasov v aplikaciji.\n\nGoogle in njegovi partnerji lahko obdelujejo informacije, kot so:\n\n• oglaševalski identifikatorji\n• podatki o napravi\n• naslov IP\n• diagnostični podatki in podatki o uporabi\n\nOd uporabnikov v določenih regijah se lahko pred prikazom prilagojenih oglasov zahteva soglasje.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK uporablja Firebase Crashlytics za prepoznavanje sesutij in izboljšanje stabilnosti aplikacije.\n\nPoročila o sesutjih lahko vključujejo tehnične informacije, kot so:\n\n• model naprave\n• različica operacijskega sistema\n• različica aplikacije\n• diagnostika sesutja\n\nPoročila o sesutjih namerno ne vključujejo vaših ocen izdelkov, zapiskov, nakupovalnih seznamov ali fotografij.",
      },
      externalProductDatabases: {
        title: "Zunanje zbirke izdelkov",
        body: "Funkcionalnost iskanja po črtni kodi lahko uporablja zunanje zbirke izdelkov za pridobivanje informacij o izdelku.\n\nZa več informacij si oglejte pravilnike o zasebnosti ustreznih ponudnikov.",
      },
    },
    dataSecurity: {
      title: "Varnost podatkov",
      body: "WasOK shrani podatke aplikacije lokalno na vaši napravi z uporabo mehanizmov shrambe, ki jih zagotavlja operacijski sistem.\n\nČeprav se sprejemajo razumni ukrepi za zaščito lokalnih podatkov aplikacije, nobena metoda elektronske shrambe ni popolnoma varna.\n\nUporabniki so odgovorni za vzdrževanje varnostnih kopij pomembnih podatkov, če to želijo.",
    },
    children: {
      title: "Zasebnost otrok",
      body: "WasOK ni namenjen otrokom, mlajšim od 13 let.",
    },
    notifications: {
      title: "Obvestila",
      body: "WasOK lahko po želji ustvari lokalna obvestila na vaši napravi, da vas opomni na ocenjevanje izdelkov po nakupu.\n\nTa obvestila se ustvarjajo in načrtujejo lokalno na vaši napravi ter ne zahtevajo računa ali oddaljenega strežnika.\n\nObvestila lahko kadar koli onemogočite v nastavitvah naprave ali v aplikaciji, če je to podprto.",
    },
    yourControl: {
      title: "Vaš nadzor nad podatki",
      body: "Lahko:\n\n• kadar koli uredite ali izbrišete shranjene izdelke\n• počistite podatke aplikacije z naprave\n• odstranite aplikacijo\n• izvozite varnostne kopije svojih podatkov",
    },
    changes: {
      title: "Spremembe tega pravilnika",
      body: "Ta pravilnik o zasebnosti se lahko občasno posodobi.\n\nSpremembe začnejo veljati z objavo posodobljene različice.",
    },
    contact: {
      title: "Kontakt",
      body: "Če imate vprašanja v zvezi s tem pravilnikom o zasebnosti, se obrnite na:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Pogoji uporabe",
    lastUpdated: "Zadnja posodobitev: 1. junij 2026",
    acceptance: {
      title: "Sprejem pogojev",
      body: "Z prenosom, namestitvijo ali uporabo WasOK se strinjate s temi pogoji uporabe.\n\nČe se s temi pogoji ne strinjate, aplikacije ne smete uporabljati.",
    },
    license: {
      title: "Licenca",
      body: "WasOK vam podeljuje omejeno, neizključno, neprenosljivo in preklicljivo licenco za uporabo aplikacije v skladu s temi pogoji.",
    },
    acceptableUse: {
      title: "Dopustna uporaba",
      body: "Strinjate se, da ne boste:\n\n• zlorabljali aplikacije\n• posegali v delovanje aplikacije\n• poskušali izvesti obratnega inženirstva ali spreminjati aplikacije\n• uporabljali aplikacije v nasprotju z veljavnimi zakoni ali predpisi",
    },
    localData: {
      title: "Lokalni podatki in varnostne kopije",
      body: "WasOK shrani uporabniške podatke lokalno na napravi.\n\nUporabniki so odgovorni za vzdrževanje varnostnih kopij pomembnih podatkov, če to želijo.\n\nČeprav je lahko na voljo funkcionalnost varnostnega kopiranja in obnovitve, WasOK ne jamči zaščite pred izgubo, poškodbo ali okvaro shranjenih podatkov.",
    },
    advertisements: {
      title: "Oglasi",
      body: "Aplikacija lahko prikazuje oglase, ki jih zagotavljajo oglaševalski partnerji tretjih oseb, vključno z Google AdMob.",
    },
    noWarranty: {
      title: "Brez jamstva",
      body: "WasOK je na voljo »takšen, kot je« in »kot je na voljo« brez jamstev kakršne koli vrste, izrecnih ali implicitnih.\n\nNe jamčimo, da:\n\n• bo aplikacija vedno na voljo\n• bo aplikacija brez napak\n• nikoli ne bo prišlo do izgube podatkov\n• bodo vse funkcije neprekinjeno delovale na vseh napravah",
    },
    limitationLiability: {
      title: "Omejitev odgovornosti",
      body: "V največjem obsegu, ki ga dovoljuje zakon, WasOK in njegovi razvijalci niso odgovorni za:\n\n• izgubo podatkov\n• izgubo dobička\n• težave z napravo\n• posredno ali posledično škodo\n• prekinitve, ki izhajajo iz uporabe ali nezmožnosti uporabe aplikacije",
    },
    thirdParty: {
      title: "Storitve tretjih oseb",
      body: "Določene funkcije ali vsebina se lahko zanašajo na storitve tretjih oseb, vključno z oglaševalskimi ponudniki in zunanjimi storitvami shrambe/deljenja, ki jih izbere uporabnik.\n\nWasOK ni odgovoren za storitve tretjih oseb ali njihove politike.",
    },
    productInformation: {
      title: "Informacije o izdelkih",
      body: "Določene podrobnosti o izdelkih se lahko pridobijo iz storitev tretjih oseb za iskanje po črtni kodi.\n\nWasOK ne jamči točnosti, popolnosti, razpoložljivosti ali primernosti informacij, ki jih zagotavljajo zunanji viri podatkov.\n\nUporabniki naj po potrebi samostojno preverijo informacije o izdelkih.",
    },
    changesApp: {
      title: "Spremembe aplikacije",
      body: "WasOK se lahko kadar koli spremeni, posodobi, začasno ustavi ali ukine brez predhodnega obvestila.",
    },
    changesTerms: {
      title: "Spremembe teh pogojev",
      body: "Ti pogoji se lahko občasno posodobijo.\n\nNadaljnja uporaba aplikacije po začetku veljavnosti posodobitev pomeni sprejem spremenjenih pogojev.",
    },
    contact: {
      title: "Kontakt",
      body: "Za vprašanja v zvezi s temi pogoji se obrnite na:\n\nsupport@wasok.app",
    },
  },
};
